/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

const getCsp = () => '/api/transverse/csp?perPage=100';

export default getCsp;
